export default "__VITE_ASSET__CR84tcgO__"